import { rem } from 'polished'
import styled from 'styled-components'

export const ImageViewerStyled = styled.div`
  font-size: ${rem(16)};

  width: 100%;
  height: 100%;
  position: relative;

  .cropper-area {
    width: 100% !important;
    height: 100% !important;
    border: none;
    box-shadow: none;
  }
`
